module.exports = __webpack_public_path__ + "img/shi_wang_shu_kou_shui.be1d4791.png";